var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConcert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 383,
    height: 391,
    viewBox: "0 0 383 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M299.125 157L226.195 83.875C225.092 68.0211 228.87 52.2095 237.021 38.5668C245.172 24.9241 257.305 14.1046 271.789 7.56359C286.273 1.02255 302.412 -0.926345 318.036 1.97903C333.661 4.8844 348.021 12.5047 359.185 23.815C370.459 35.0077 378.046 49.3759 380.932 64.9978C383.817 80.6196 381.864 96.7501 375.334 111.232C368.803 125.714 358.006 137.856 344.388 146.035C330.769 154.214 314.977 158.04 299.125 157ZM28.0751 299.35L207.475 120.145L262.66 175.33L83.2601 354.73L28.2701 299.35H28.0751ZM0.775078 354.535L41.9201 313.195L69.6101 340.885L28.2701 382.225L0.580078 354.535H0.775078ZM187 293.5L226 254.5V391H187V293.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcert);
export default __webpack_public_path__ + "static/media/concert.7f6096f3d710d20a7e55c76ece669555.svg";
export { ForwardRef as ReactComponent };